// extracted by mini-css-extract-plugin
module.exports = {"input":"input-otp_input__2TL5y","error":"input-otp_error__2AfEz"};